export default "__VITE_ASSET__CR6il$0D__"